import { FileSizes } from '../../enums/file-sizes.enum';

export const getByteReference = (transformTo: FileSizes): number | null => {
  switch (transformTo) {
    case FileSizes.MegaBytes:
      return 1048576;
    case FileSizes.GigaBytes:
      return 1073741824;
    default:
      return null;
  }
};
